module.exports = __webpack_public_path__ + "img/daa49fb.png";